// 注册中心名称
const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
// 产品API
const product = {
  // 获取快递公司
  getCourierCompany: {
    type: 'get',
    url: `${apiName}/returnManagement/getCourierCompany`
  },

  // 根据电商单号获取原快递单号
  getCourierNumber: {
    type: 'get',
    url: `${apiName}/returnManagement/getCourierNumber`
  },

  getGoodsReturn: {
    type: 'post',
    url: `${apiName}/returnManagement/getGoodsReturn`
  },
  getGoods: {
    type: 'get',
    url: `${apiName}/returnManagement/getGoods`
  },

  // 退货编辑-新增退货
  add: {
    type: 'post',
    url: `${apiName}/returnManagement/add`
  },

  // 退货编辑-获取退货编辑信息
  modifyData: {
    type: 'get',
    url: `${apiName}/returnManagement/modifyData/get`
  },
  // 退货编辑-编辑
  modify: {
    type: 'post',
    url: `${apiName}/returnManagement/modify`
  },

  // 退货管理-终止
  handleUnbind: {
    type: 'post',
    url: `${apiName}/returnManagement/updateStatus`
  },

  // 基础配置-查询
  getReturn: {
    type: 'post',
    url: `${apiName}/returnManagement/getReturn`
  },
  // 基础配置-新增
  insertReturn: {
    type: 'post',
    url: `${apiName}/returnManagement/insertReturn`
  },
  // 基础配置-编辑
  updateReturn: {
    type: 'post',
    url: `${apiName}/returnManagement/updateReturn`
  },

  // 基础配置-停用
  updateState: {
    type: 'get',
    url: `${apiName}/returnManagement/updateState`
  },


  // 收货确认-列表
  receiptConfirmList: {
    type: 'post',
    url: `${apiName}/returnManagement/receiptConfirm/pageList`
  },

  // 收货确认-确认信息获取
  receiptConfirmGet: {
    type: 'get',
    url: `${apiName}/returnManagement/receiptConfirm/get`
  },

  // 收货确认-确认信息获取
  receiptConfirm: {
    type: 'post',
    url: `${apiName}/returnManagement/receiptConfirm/submit`
  },

  // 收货确认-编辑信息获取
  receiptmodifyGet: {
    type: 'get',
    url: `${apiName}/returnManagement/receiptConfirm/modify/get`
  },

  // 收货确认-编辑-确认编辑
  receiptmodify: {
    type: 'post',
    url: `${apiName}/returnManagement/receiptConfirm/modify`
  },

  // 收货确认-详情
  receiptDetail: {
    type: 'get',
    url: `${apiName}/returnManagement/receiptConfirm/get`
  },
};


export default product;
